var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticClass:"text-center"},[_c('i',{staticClass:"fa fa-spinner fa-spin fa-fw",class:{'fa-4x': !_vm.is_small, 'text-white': _vm.is_white}}),_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }